import { computed, ref } from "vue";
import { defineStore } from "pinia";
import {
  JpuDTO,
  ReadServerStatusResponse,
  ViewContext,
} from "@shared/types/common";

export const useJpdStore = defineStore("jpd-store", () => {
  // State
  const _currentJpds = ref<Record<ViewContext, JpuDTO>>({
    IP_ALLOWLIST: {} as JpuDTO,
    PRIVATE_CONNECTIONS: {} as JpuDTO,
    GEOLOCATION_RESTRICTIONS: {} as JpuDTO,
  });
  const _activeServersStatus = ref<ReadServerStatusResponse>({});
  const _isLoadingServerStatus = ref<boolean>(true);

  // Getters
  const currentJpds = computed(() => _currentJpds.value);
  const activeServersStatus = computed(() => _activeServersStatus.value);
  const isLoadingServerStatus = computed(() => _isLoadingServerStatus.value);

  // Actions
  const setCurrentJpdForContext = ({
    context,
    jpd,
  }: {
    jpd: JpuDTO;
    context: ViewContext;
  }) => {
    _currentJpds.value[context] = jpd;
  };

  const setActiveServersStatus = (status: ReadServerStatusResponse) => {
    _activeServersStatus.value = status;
  };

  const setIsLoadingServerStatus = (isLoading: boolean) => {
    _isLoadingServerStatus.value = isLoading;
  };

  return {
    currentJpds,
    activeServersStatus,
    isLoadingServerStatus,
    setCurrentJpdForContext,
    setActiveServersStatus,
    setIsLoadingServerStatus,
  };
});
